"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getOffset = function (gapMode) {
    var cs = window.getComputedStyle(document.body);
    var value = cs[gapMode === 'padding' ? 'paddingRight' : 'marginRight'];
    return parseInt(value || '', 10) || 0;
};
exports.getGapWidth = function (gapMode) {
    if (typeof window === 'undefined') {
        return 0;
    }
    var currentOffset = getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return Math.max(0, windowWidth - documentWidth + currentOffset);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-scroll-locky/dist/utils.js
// module id = 78
// module chunks = 0